import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { HTTPError, objectToQueryString, booleanToString } from './libs';
export var CASClient = /*#__PURE__*/function () {
  function CASClient(config) {
    _classCallCheck(this, CASClient);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "loginExecutionParams", void 0);

    this.config = _Object$assign({}, config, {
      casUrl: config.casUrl.replace(/\/+$/, '')
    });
  }

  _createClass(CASClient, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var endpoint, response, body;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                endpoint = this.getEndpoint(_Object$assign({
                  path: 'login',
                  serviceUrl: this.config.serviceUrl
                }, params));
                _context.next = 4;
                return fetch(endpoint, CASClient.getRequestOptionsForGET());

              case 4:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context.next = 9;
                return response.json();

              case 9:
                body = _context.sent;

                if (!body.success) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", {
                  success: true,
                  state: body
                });

              case 12:
                return _context.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject(body)
                });

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject()
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 15]]);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getLoginParams",
    value: function () {
      var _getLoginParams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        var endpoint, response, body, _obj$username, obj;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                endpoint = this.getEndpoint(_Object$assign({
                  path: 'login',
                  serviceUrl: this.config.serviceUrl
                }, params), true);
                _context2.next = 4;
                return fetch(endpoint, CASClient.getRequestOptionsForGET());

              case 4:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context2.next = 9;
                return response.json();

              case 9:
                body = _context2.sent;

                if (!body.form_defaults) {
                  _context2.next = 14;
                  break;
                }

                obj = body.form_defaults;
                this.loginExecutionParams = {
                  lt: obj.lt,
                  execution: obj.executionKey,
                  _eventId: obj._eventId
                };
                return _context2.abrupt("return", {
                  success: true,
                  state: {
                    username: (_obj$username = obj.username) !== null && _obj$username !== void 0 ? _obj$username : '',
                    rememberUsername: !!obj.rememberUsername,
                    rememberMe: !!obj.keepMeLoggedIn
                  }
                });

              case 14:
                return _context2.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject(body)
                });

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject()
                });

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 17]]);
      }));

      function getLoginParams(_x2) {
        return _getLoginParams.apply(this, arguments);
      }

      return getLoginParams;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
        var username, password, rememberMe, rememberUsername, token, renew, endpoint, response, body;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                username = _ref.username, password = _ref.password, rememberMe = _ref.rememberMe, rememberUsername = _ref.rememberUsername, token = _ref.token, renew = _ref.renew;
                _context3.prev = 1;
                endpoint = this.getEndpoint({
                  path: 'login',
                  serviceUrl: this.config.serviceUrl,
                  renew: renew
                }, true);
                _context3.next = 5;
                return fetch(endpoint, CASClient.createOptionsForPOST({
                  headers: _Object$assign({
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }, token && {
                    'X-Captcha-Token': token
                  }),
                  body: objectToQueryString(_Object$assign({
                    username: username,
                    password: password,
                    rememberMe: rememberMe,
                    rememberUsername: rememberUsername,
                    _rememberUsername: booleanToString(rememberUsername),
                    _rememberMe: booleanToString(rememberMe)
                  }, this.loginExecutionParams))
                }));

              case 5:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 8;
                  break;
                }

                throw new HTTPError(response);

              case 8:
                _context3.next = 10;
                return response.json();

              case 10:
                body = _context3.sent;

                if (!body.success) {
                  _context3.next = 13;
                  break;
                }

                return _context3.abrupt("return", {
                  success: true,
                  state: body
                });

              case 13:
                return _context3.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject(body)
                });

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](1);
                return _context3.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject()
                });

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 16]]);
      }));

      function login(_x3) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "loginByToken",
    value: function () {
      var _loginByToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref2) {
        var token, renew, endpoint, response, body;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                token = _ref2.token, renew = _ref2.renew;
                _context4.prev = 1;
                endpoint = this.getEndpoint({
                  path: 'tokenlogin',
                  serviceUrl: this.config.serviceUrl,
                  renew: renew
                });
                _context4.next = 5;
                return fetch(endpoint, CASClient.createOptionsForPOST({
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: _JSON$stringify({
                    token: token
                  })
                }));

              case 5:
                response = _context4.sent;

                if (response.ok) {
                  _context4.next = 8;
                  break;
                }

                throw new HTTPError(response);

              case 8:
                _context4.next = 10;
                return response.json();

              case 10:
                body = _context4.sent;

                if (!body.success) {
                  _context4.next = 13;
                  break;
                }

                return _context4.abrupt("return", {
                  success: true,
                  state: body
                });

              case 13:
                return _context4.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject(body)
                });

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](1);
                return _context4.abrupt("return", {
                  success: false,
                  error: CASClient.createErrorObject()
                });

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 16]]);
      }));

      function loginByToken(_x4) {
        return _loginByToken.apply(this, arguments);
      }

      return loginByToken;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _body$success, endpoint, response, body;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                endpoint = this.getEndpoint({
                  path: 'logout'
                });
                _context5.next = 4;
                return fetch(endpoint, CASClient.getRequestOptionsForGET());

              case 4:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context5.next = 9;
                return response.json();

              case 9:
                body = _context5.sent;
                return _context5.abrupt("return", {
                  success: (_body$success = body.success) !== null && _body$success !== void 0 ? _body$success : body.logoutSuccess
                });

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", {
                  success: false
                });

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 13]]);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "imAlive",
    value: function () {
      var _imAlive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var endpoint, response, body;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                endpoint = this.getEndpoint({
                  path: 'imAlive'
                });
                _context6.next = 4;
                return fetch(endpoint, CASClient.getRequestOptionsForGET());

              case 4:
                response = _context6.sent;

                if (response.ok) {
                  _context6.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context6.next = 9;
                return response.json();

              case 9:
                body = _context6.sent;
                return _context6.abrupt("return", {
                  success: response.ok,
                  state: {
                    timeToKill: body.timeToKill,
                    expiresAt: body.expiresAt
                  }
                });

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](0);

                if (!(_context6.t0 instanceof HTTPError)) {
                  _context6.next = 17;
                  break;
                }

                throw _context6.t0;

              case 17:
                return _context6.abrupt("return", {
                  success: false,
                  state: {
                    timeToKill: -1,
                    expiresAt: -1
                  }
                });

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 13]]);
      }));

      function imAlive() {
        return _imAlive.apply(this, arguments);
      }

      return imAlive;
    }()
  }, {
    key: "getEndpoint",
    value: function getEndpoint(_ref3) {
      var path = _ref3.path,
          serviceUrl = _ref3.serviceUrl,
          gateway = _ref3.gateway,
          custLogin = _ref3.custLogin,
          renew = _ref3.renew;
      var useFeatureFlags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var version = '';

      if (useFeatureFlags) {
        if (this.config.enableRecaptcha) {
          version = '/v3';
        } else if (this.config.enableFlagHandling) {
          version = '/v2';
        }
      }

      var params = [serviceUrl ? "service=".concat(encodeURIComponent(serviceUrl)) : null, gateway ? 'gateway=true' : null, custLogin ? 'cust_login=true' : null, renew ? 'renew=true' : null].filter(function (param) {
        return param !== null;
      }).join('&');
      var query = params ? "?".concat(params) : '';
      return "".concat(this.config.casUrl).concat(version, "/").concat(path).concat(query);
    }
  }], [{
    key: "createErrorObject",
    value: function createErrorObject() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var error = {
        code: '',
        message: '',
        placeholders: obj.placeholders
      };

      if (obj.failure) {
        error.code = obj.failure;
      } else if (obj.success === true) {
        error.code = 'error.authentication.already.logged.in';
      } else if (obj.success === false) {
        error.code = 'error.authentication.max.attempts';
      } else {
        error.code = 'error.authentication.general';
      }

      if (obj.flag || obj.token) {
        var _obj$flag, _obj$token;

        error.data = {
          flag: (_obj$flag = obj.flag) !== null && _obj$flag !== void 0 ? _obj$flag : null,
          token: (_obj$token = obj.token) !== null && _obj$token !== void 0 ? _obj$token : null
        };
      }

      return error;
    }
  }, {
    key: "getRequestOptionsForGET",
    value: function getRequestOptionsForGET() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          headers = _ref4.headers;

      return {
        method: 'GET',
        headers: _Object$assign({
          Accept: 'application/json'
        }, headers),
        credentials: 'include'
      };
    }
  }, {
    key: "createOptionsForPOST",
    value: function createOptionsForPOST() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          headers = _ref5.headers,
          body = _ref5.body;

      return {
        method: 'POST',
        headers: _Object$assign({
          Accept: 'application/json',
          'Accept-Language': 'ql'
        }, headers),
        body: body,
        credentials: 'include'
      };
    }
  }]);

  return CASClient;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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